import React,{useEffect,useState} from "react";

import {
    Card,
    Space,
    Avatar,
    Typography,
    Row,
    Col,
    Divider,
    Spin
} from "antd";

import {
    CalendarOutlined,
    TeamOutlined,
    ManOutlined,
    CreditCardOutlined
} from "@ant-design/icons";

import { motion } from "framer-motion";

import api from "../../api/api";
import { useAcademicYear } from "../../AcademicYearContext";


const {Title,Text}=Typography;


const YearlySchoolFeeCount=({theme})=>{

    const {selectedYear}=useAcademicYear();

    const [loading,setLoading]=useState(false);

    const [fee,setFee]=useState({
        academic_year:"",
        total_students:0,
        total_fee:0,

    });


    useEffect(()=>{

        if(!selectedYear) return;

        fetchYearlyFee();

    },[selectedYear]);


    const fetchYearlyFee=async()=>{

        try{

            setLoading(true);

            const res=await api.get(
                `/yearly-school-fees/?academic_year=${selectedYear.id}`
            );

            setFee(res.data);


        }catch(error){

            console.log(error);

        }finally{

            setLoading(false);

        }

    };


    return(

    <motion.div
      whileHover={{ y:-4 }}
      transition={{duration:.25}}
    >

      <Card
        bodyStyle={{padding:18}}
        style={{
          background:theme.card,
          borderRadius:16,
          border:`1px solid ${theme.border}`,
        }}
      >

        {
          loading ?

          <div
            style={{
              display:"flex",
              justifyContent:"center",
              padding:30
            }}
          >
            <Spin/>
          </div>

          :

          <>

          <Space align="center">

            <Avatar
              size={56}
              style={{
                background:"#8B4513",
                fontSize:24
              }}
            >
              <CalendarOutlined/>
            </Avatar>


            <div>

              <Text
                style={{
                  color:theme.secondary
                }}
              >
                Yearly School Fee
              </Text>


              <Title
                level={2}
                style={{
                  margin:0,
                  color:theme.text
                }}
              >

                {
                  new Intl.NumberFormat(
                    "en-US",
                    {
                      style:"currency",
                      currency:"USD"
                    }
                  ).format(
                    fee.total_fee || 0
                  )
                }

              </Title>


              <Text
                style={{
                  color:"#999"
                }}
              >
                Total School fees paid this year!
              </Text>

            </div>

          </Space>


          <Divider
            style={{
              margin:"16px 0"
            }}
          />


          <Row gutter={18}>


            <Col span={12}>

              <Space>

                <Avatar
                  style={{
                    background:"#5A0B16"
                  }}
                >
                  <TeamOutlined/>
                </Avatar>


                <div>

                  <Text type="secondary">
                    Students
                  </Text>


                  <Title
                    level={4}
                    style={{
                      margin:0,
                      color:theme.text
                    }}
                  >
                    {fee.total_students}
                  </Title>


                </div>

              </Space>

            </Col>



            <Col span={12}>

              <Space>

                <Avatar
                  style={{
                    background:"#1677ff"
                  }}
                >
                  <CreditCardOutlined/>
                </Avatar>


                <div>

            </div>

                              <Text
                style={{
                  color:"#999"
                }}
              >
                {fee.academic_year || selectedYear?.name}
              </Text>

              </Space>

              


            </Col>


          </Row>





          </>

        }


      </Card>


    </motion.div>

    );

};


export default YearlySchoolFeeCount;
